import script from "./OrganizationAccountList.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganizationAccountList.vue?vue&type=script&setup=true&lang=js"

import "./OrganizationAccountList.vue?vue&type=style&index=0&id=37691e5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37691e5c"]])

export default __exports__